import Formulario from '../../containers/Formulario'
import Sidebar from '../../containers/Sidebar'

const Cadastro = () => (
  <>
    <Sidebar mostrarFiltros={false} />
    <Formulario />
  </>
)

export default Cadastro
